import { i as intelliSuggest, t as trapFocus, P as PaginationController } from "./searchspring-intelliSuggest-D_vaMJHn.js";
import { s as setAndGetSearchspringCookies } from "./manageSearchSpringCookies-BlSmBYu9.js";
import { r as renderProductCardsFromHandles } from "./render-product-cards-C86dq60y.js";
import { d as debounce } from "./_debounce-CeGyIUiF.js";
class Collection {
  //------------------------------------------------------------------------------------------------
  constructor() {
    this.$collectionContainer = document.getElementById("js-collection-container");
    this.$productGrid = document.getElementById("js-collection-product-grid");
    this.$loadMoreButtonWrapper = document.getElementById("js-show-more-trigger-wrapper");
    this.$loadMoreButton = document.getElementById("js-show-more-trigger");
    this.$totalProductCounts = document.querySelectorAll(".js-total-product-count");
    this.$currentProductCount = document.getElementById("js-current-product-count");
    this.$filtersDrawerWrapper = document.getElementById("js-collection-filters-drawer-wrapper");
    this.$filtersBackdrop = document.getElementById("js-collection-filters-backdrop");
    this.$filtersDrawer = document.getElementById("js-collection-filters-drawer");
    this.$filtersContent = document.getElementById("js-collection-filters-content");
    this.$filtersButton = document.getElementById("js-filters-trigger");
    this.$filtersCloseButton = document.getElementById("js-close-filters-button");
    this.$filtersApplyButton = document.getElementById("js-apply-filters-button");
    this.$filtersClearButtonWrapper = document.getElementById("js-clear-filters-button-wrapper");
    this.$filtersClearButtons = document.querySelectorAll(".js-clear-filters-button");
    this.$filterCountTotals = document.querySelectorAll(".js-filter-count-total");
    this.$filterSummaryWrapper = document.getElementById("js-filter-summary-wrapper");
    this.$filterSummary = document.getElementById("js-filter-summary");
    this.activeFilterGroupIndex = null;
    this.$sortModalWrapper = document.getElementById("js-collection-sort-modal-wrapper");
    this.$sortModal = document.getElementById("js-collection-sort-modal");
    this.$sortContent = document.getElementById("js-collection-sort-content");
    this.$sortButton = document.getElementById("js-collection-sort-trigger");
    this.$sortLabel = document.getElementById("js-collection-sort-label");
    this.ssId = SDG.Data.ssId;
    this.isDesktop = window.innerWidth > 768;
    this.desktopInitialBatchSize = 24;
    this.desktopSilentTargetCount = 100;
    this.desktopPostTargetBatchSize = 100;
    this.enableDesktopStagedLoading = this.isDesktop;
    this.prefetchedOverflowProducts = [];
    this.renderedProductKeys = /* @__PURE__ */ new Set();
    this.renderedProductCount = 0;
    this.silentPrefetchInProgress = false;
    this.silentPrefetchToken = 0;
    this.hasReachedSilentTarget = false;
    this.largeBatchPageInfo = 1;
    this.queryStateToken = 0;
    this.hasDeferredInitRun = false;
    this.hasDeferredEventListeners = false;
    this.needsDeferredVideoObserverInit = false;
    this.defaultResultsPerPage = window.innerWidth > 768 ? _JK.collections.deskResultsPerPage : _JK.collections.mobResultsPerPage;
    this.resultsPerPage = this.enableDesktopStagedLoading ? this.desktopInitialBatchSize : this.defaultResultsPerPage;
    this.pageInfo = 1;
    this.collectionId = this.$productGrid ? this.$productGrid.dataset.collectionId : null;
    this.collectionHandle = this.$productGrid ? this.$productGrid.dataset.collectionHandle : null;
    this.url = window.location.href;
    this.urlParams = new URLSearchParams(window.location.search);
    this.activeFilters = this.getFiltersFromUrl();
    const [sortData] = this.getSortFromUrl();
    this.sort = (sortData == null ? void 0 : sortData.key) || null;
    this.sortOrder = (sortData == null ? void 0 : sortData.value) || "asc";
    this.ssUrl = this.formatSearchSpringUrl();
    this.debouncedShowMoreProducts = debounce(() => {
      void this.showMoreProducts();
    }, 300);
  }
  //------------------------------------------------------------------------------------------------
  async init() {
    const queryToken = ++this.queryStateToken;
    const ssData = await this.fetchSearchSpringData(queryToken);
    if (!ssData) return;
    this.initPage(ssData, "replace");
    this.addEventListeners();
  }
  //------------------------------------------------------------------------------------------------
  initPage(ssData, action = "replace") {
    if (!ssData) {
      console.warn("No ssData found for this collection.");
      this.$productGrid.innerHTML = '<p class="text-red-100 redesign-body-3">ERROR: No data found for this collection.</p>';
      return;
    }
    this.productsData = ssData.results;
    this.filtersData = ssData.facets || [];
    this.sortData = ssData.sorting || [];
    this.filterSummaryData = ssData.filterSummary || {};
    this.paginationData = ssData.pagination || {};
    this.isProductTypeEnabled = this.$productGrid.dataset.isProductTypeEnabled === "true";
    this.isBestsellerScoreEnabled = String(this.$productGrid.dataset.isBestsellerScoreEnabled).trim().toLowerCase() === "true";
    this.enableProductCardVideos = String(this.$productGrid.dataset.enableProductCardVideos).trim().toLowerCase() === "true";
    this.useThreeProductsPerRow = String(this.$productGrid.dataset.useThreeProductsPerRow).trim().toLowerCase() === "true";
    this.isCollectionGridInsertEnabled = String(this.$productGrid.dataset.isCollectionGridInsertEnabled).trim().toLowerCase() === "true";
    this.collectionGridInsertData = this.$productGrid.dataset.collectionGridInsert || "";
    this.isCollectionGridInsert2Enabled = String(this.$productGrid.dataset.isCollectionGridInsertTwoEnabled).trim().toLowerCase() === "true";
    this.collectionGridInsert2Data = this.$productGrid.dataset.collectionGridInsertTwo || "";
    this.isCollectionGridInsert3Enabled = String(this.$productGrid.dataset.isCollectionGridInsertThreeEnabled).trim().toLowerCase() === "true";
    this.collectionGridInsert3Data = this.$productGrid.dataset.collectionGridInsertThree || "";
    this.isCollectionGridInsert4Enabled = String(this.$productGrid.dataset.isCollectionGridInsertFourEnabled).trim().toLowerCase() === "true";
    this.collectionGridInsert4Data = this.$productGrid.dataset.collectionGridInsertFour || "";
    if (action === "replace") {
      this.resetStagedLoadingState();
    }
    this.displayProducts(action);
    if (!this.filtersInitialized) {
      this.addActiveFilters();
      this.initFiltersAccordion();
      this.filtersInitialized = true;
      this.updateCounts();
    } else {
      this.filtersData = ssData.facets;
      this.updateCounts();
      this.updateFilterStates();
    }
    this.displayFilterSummary();
  }
  //------------------------------------------------------------------------------------------------
  resetStagedLoadingState() {
    this.silentPrefetchToken += 1;
    this.silentPrefetchInProgress = false;
    this.prefetchedOverflowProducts = [];
    this.renderedProductKeys = /* @__PURE__ */ new Set();
    this.renderedProductCount = 0;
    this.hasReachedSilentTarget = false;
    this.largeBatchPageInfo = 1;
    this.resultsPerPage = this.enableDesktopStagedLoading ? this.desktopInitialBatchSize : this.defaultResultsPerPage;
  }
  //------------------------------------------------------------------------------------------------
  getProductKey(product) {
    return String((product == null ? void 0 : product.uid) || (product == null ? void 0 : product.id) || (product == null ? void 0 : product.handle) || "");
  }
  //------------------------------------------------------------------------------------------------
  updateRenderedCountUI() {
    var _a;
    if (!this.$currentProductCount) return;
    this.$currentProductCount.innerHTML = this.renderedProductCount || ((_a = this.paginationData) == null ? void 0 : _a.end) || 0;
  }
  //------------------------------------------------------------------------------------------------
  updateLoadMoreVisibility() {
    var _a, _b;
    if (!this.$loadMoreButtonWrapper) return;
    if (this.silentPrefetchInProgress) {
      this.$loadMoreButtonWrapper.classList.add("hidden");
      return;
    }
    const hasOverflow = this.prefetchedOverflowProducts.length > 0;
    const hasMoreApiPages = ((_a = this.paginationData) == null ? void 0 : _a.currentPage) < ((_b = this.paginationData) == null ? void 0 : _b.totalPages);
    if (hasOverflow || hasMoreApiPages) {
      this.$loadMoreButtonWrapper.classList.remove("hidden");
    } else {
      this.$loadMoreButtonWrapper.classList.add("hidden");
    }
  }
  // **************************************************************************
  // EVENTS
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  addEventListeners() {
    [
      this.$filtersButton,
      this.$filtersBackdrop,
      this.$filtersCloseButton,
      this.$filtersApplyButton
    ].forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleFiltersDrawer();
      });
    });
    this.$filtersClearButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.clearFilters();
        this.handleFilterChange("", "");
      });
    });
    this.addFilterOptionListeners();
    this.$sortButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleSortModal();
    });
    this.$sortContent.addEventListener("change", (e) => {
      var _a, _b, _c;
      if (e.target.matches('.js-sort-option[type="radio"]') && e.target instanceof HTMLInputElement) {
        this.sort = ((_a = e.target.dataset) == null ? void 0 : _a.sort) || null;
        this.sortLabel = ((_b = e.target.dataset) == null ? void 0 : _b.sortLabel) || null;
        this.sortOrder = ((_c = e.target.dataset) == null ? void 0 : _c.sortOrder) || null;
        this.handleSortChange();
      }
    });
    this.$loadMoreButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.debouncedShowMoreProducts();
    });
  }
  //------------------------------------------------------------------------------------------------
  addDeferredEventListeners() {
    if (this.hasDeferredEventListeners || !this.$productGrid) return;
    this.hasDeferredEventListeners = true;
    this.$productGrid.addEventListener("click", (e) => {
      const pauseBtn = e.target.closest(".js-collection-grid-video-pause-btn");
      const playBtn = e.target.closest(".js-collection-grid-video-play-btn");
      if (!pauseBtn && !playBtn) return;
      e.preventDefault();
      e.stopPropagation();
      const mediaRoot = (pauseBtn || playBtn).closest(".js-collection-grid-insert-media");
      const video = mediaRoot == null ? void 0 : mediaRoot.querySelector(".js-collection-grid-insert-video");
      const mediaPauseBtn = mediaRoot == null ? void 0 : mediaRoot.querySelector(".js-collection-grid-video-pause-btn");
      const mediaPlayBtn = mediaRoot == null ? void 0 : mediaRoot.querySelector(".js-collection-grid-video-play-btn");
      if (!video || !mediaPauseBtn || !mediaPlayBtn) return;
      if (pauseBtn) {
        video.pause();
        mediaPauseBtn.classList.add("hidden");
        mediaPlayBtn.classList.remove("hidden");
      } else {
        video.play();
        mediaPlayBtn.classList.add("hidden");
        mediaPauseBtn.classList.remove("hidden");
      }
    });
  }
  //------------------------------------------------------------------------------------------------
  scheduleDeferredPostPaintInit() {
    if (this.hasDeferredInitRun) return;
    this.hasDeferredInitRun = true;
    const runDeferredInit = () => {
      this.initSort();
      this.addDeferredEventListeners();
      if (this.needsDeferredVideoObserverInit) {
        this.needsDeferredVideoObserverInit = false;
        this.initCollectionGridInsertVideoObserver();
      }
    };
    requestAnimationFrame(() => {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(runDeferredInit, { timeout: 800 });
      } else {
        setTimeout(runDeferredInit, 0);
      }
    });
  }
  //------------------------------------------------------------------------------------------------
  addFilterOptionListeners() {
    this.$filtersContent.addEventListener("change", (e) => {
      if (e.target.matches('.js-filter-option[type="checkbox"]') && e.target instanceof HTMLInputElement) {
        const input = e.target;
        const filterKey = input.dataset.filter;
        const filterValue = input.dataset.value;
        this.handleFilterChange(filterKey, filterValue);
      }
    });
  }
  // **************************************************************************
  // SEARCHSPRING METHODS
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  async fetchSearchSpringData(expectedQueryToken = this.queryStateToken) {
    try {
      const response = await fetch(this.ssUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (expectedQueryToken !== this.queryStateToken) {
        return null;
      }
      return data;
    } catch (error) {
      console.error("Error fetching SS Data:", error);
      console.error(`  - ERR ssURL: ${this.ssUrl}`);
      return null;
    }
  }
  //------------------------------------------------------------------------------------------------
  formatSearchSpringUrl() {
    const {
      sessionCookie,
      userId,
      pageLoadId
    } = setAndGetSearchspringCookies();
    const ssBaseUrl = `https://${this.ssId}.a.searchspring.io/api/search/search.json`;
    const params = {
      domain: `/collections/${this.collectionHandle}`,
      resultsFormat: "native",
      siteId: this.ssId,
      sessionId: sessionCookie,
      userId,
      pageLoadId,
      resultsPerPage: this.resultsPerPage,
      page: this.pageInfo,
      "bgfilter.collection_id": this.collectionId
    };
    const ssParams = new URLSearchParams(params);
    if (this.activeFilters) {
      this.activeFilters.forEach((filter) => {
        ssParams.append(filter.key, filter.value);
      });
    }
    if (this.sort && this.sortOrder) {
      ssParams.append(`${this.sort}`, this.sortOrder);
    }
    const ssUrl = `${ssBaseUrl}?${ssParams.toString()}`;
    return ssUrl;
  }
  //------------------------------------------------------------------------------------------------
  async displayProducts(action, productsOverride = null) {
    const sourceProducts = productsOverride || this.productsData;
    if (!sourceProducts || sourceProducts.length === 0) {
      this.$productGrid.innerHTML = '<p class="redesign-body-4 text-charcoal-100">No products available in this collection.</p>';
      return;
    }
    if (action === "replace") {
      this.renderedProductKeys.clear();
      this.renderedProductCount = 0;
    }
    intelliSuggest(sourceProducts);
    const productsToRender = sourceProducts.filter((product) => {
      const key = this.getProductKey(product);
      if (!key || this.renderedProductKeys.has(key)) return false;
      return true;
    });
    const handlesToRender = productsToRender.map((product) => product.handle).filter(Boolean);
    if (!handlesToRender.length) {
      this.updateRenderedCountUI();
      this.updateLoadMoreVisibility();
      return;
    }
    const cardClasses = this.useThreeProductsPerRow ? ["basis-[calc(50%-4px)]", "lg:basis-[calc(33.333%_-_5.333px)]"] : ["basis-[calc(50%-4px)]", "lg:basis-[calc(25%_-_8px)]"];
    const cardView = this.enableProductCardVideos ? "get-product-card-video" : "get-product-card";
    await renderProductCardsFromHandles(
      handlesToRender,
      this.$productGrid,
      {
        view: cardView,
        cardClasses,
        action
      }
    );
    productsToRender.forEach((product) => {
      const key = this.getProductKey(product);
      if (key) this.renderedProductKeys.add(key);
    });
    this.renderedProductCount = this.renderedProductKeys.size;
    this.applyCollectionGridInsertLayout(action);
    this.updateRenderedCountUI();
    this.updateLoadMoreVisibility();
    if (action === "replace") {
      this.scheduleDeferredPostPaintInit();
    }
    if (action === "replace" && this.enableDesktopStagedLoading) {
      void this.prefetchDesktopBatchesToTarget();
    }
  }
  //------------------------------------------------------------------------------------------------
  async prefetchDesktopBatchesToTarget() {
    var _a, _b;
    if (!this.enableDesktopStagedLoading || this.silentPrefetchInProgress || this.hasReachedSilentTarget) return;
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const effectiveType = (connection == null ? void 0 : connection.effectiveType) || "";
    const shouldSkipSilentPrefetch = Boolean(
      (connection == null ? void 0 : connection.saveData) || effectiveType === "slow-2g" || effectiveType === "2g"
    );
    if (shouldSkipSilentPrefetch) return;
    this.silentPrefetchInProgress = true;
    this.updateLoadMoreVisibility();
    const prefetchToken = ++this.silentPrefetchToken;
    const queryToken = this.queryStateToken;
    try {
      while (prefetchToken === this.silentPrefetchToken && queryToken === this.queryStateToken && this.renderedProductCount < this.desktopSilentTargetCount && ((_a = this.paginationData) == null ? void 0 : _a.currentPage) < ((_b = this.paginationData) == null ? void 0 : _b.totalPages)) {
        this.pageInfo += 1;
        this.ssUrl = this.formatSearchSpringUrl();
        const ssData = await this.fetchSearchSpringData(queryToken);
        if (!ssData) break;
        this.paginationData = ssData.pagination || this.paginationData;
        const remainingToTarget = this.desktopSilentTargetCount - this.renderedProductCount;
        const nextResults = ssData.results || [];
        const renderNow = nextResults.slice(0, Math.max(remainingToTarget, 0));
        const overflow = nextResults.slice(Math.max(remainingToTarget, 0));
        if (renderNow.length) {
          await this.displayProducts("append", renderNow);
        }
        if (overflow.length) {
          this.prefetchedOverflowProducts.push(...overflow);
          break;
        }
      }
      this.hasReachedSilentTarget = this.renderedProductCount >= this.desktopSilentTargetCount;
      if (this.hasReachedSilentTarget) {
        this.resultsPerPage = this.desktopPostTargetBatchSize;
        this.largeBatchPageInfo = Math.max(1, Math.floor(this.renderedProductCount / this.desktopPostTargetBatchSize));
      }
    } finally {
      if (prefetchToken === this.silentPrefetchToken) {
        this.silentPrefetchInProgress = false;
      }
      this.updateLoadMoreVisibility();
    }
  }
  //------------------------------------------------------------------------------------------------
  shouldRenderCollectionGridInsert() {
    const hasNoActiveFilters = !this.activeFilters || this.activeFilters.length === 0;
    return !this.useThreeProductsPerRow && this.isCollectionGridInsertEnabled && hasNoActiveFilters;
  }
  //------------------------------------------------------------------------------------------------
  applyCollectionGridInsertLayout(action = "replace") {
    if (!this.$productGrid) return;
    if (action === "replace") {
      this.clearCollectionGridInsertLayout();
    }
    const productTiles = Array.from(this.$productGrid.children).filter(
      (el) => !el.classList.contains("js-collection-grid-insert") && !el.classList.contains("js-collection-grid-insert-2") && !el.classList.contains("js-collection-grid-insert-3") && !el.classList.contains("js-collection-grid-insert-4")
    );
    productTiles.forEach((tile, index) => {
      tile.classList.remove("js-collection-mobile-odd");
      if (index % 2 === 0) {
        tile.classList.add("js-collection-mobile-odd");
      }
    });
    const productsCount = productTiles.length;
    const hasFullBlockAtIndex = (startIndex, blockSize = 4) => productsCount >= startIndex + blockSize;
    const shouldInsert1 = this.shouldRenderCollectionGridInsert(action) && productsCount >= 4;
    const secondInsertProductsStartIndex = 12;
    const shouldInsert2 = shouldInsert1 && this.shouldRenderCollectionGridInsert2(action) && hasFullBlockAtIndex(secondInsertProductsStartIndex);
    const thirdInsertProductsStartIndex = 24;
    const shouldInsert3 = shouldInsert2 && this.shouldRenderCollectionGridInsert3(action) && hasFullBlockAtIndex(thirdInsertProductsStartIndex);
    const fourthInsertProductsStartIndex = 36;
    const shouldInsert4 = shouldInsert3 && this.shouldRenderCollectionGridInsert4(action) && hasFullBlockAtIndex(fourthInsertProductsStartIndex);
    if (!shouldInsert1 && !shouldInsert2 && !shouldInsert3 && !shouldInsert4) {
      if (this.hasDeferredInitRun) {
        this.initCollectionGridInsertVideoObserver();
      } else {
        this.needsDeferredVideoObserverInit = true;
      }
      return;
    }
    if (shouldInsert1 && !this.$productGrid.querySelector(".js-collection-grid-insert")) {
      this.insertCollectionGridInsert({
        insertClass: "js-collection-grid-insert",
        dataSource: this.collectionGridInsertData,
        desktopPlacementClasses: "lg:col-start-3 lg:row-start-1",
        insertPosition: 4,
        templateId: "js-collection-grid-insert-template-1"
      });
      const firstFourPlacementClasses = [
        ["lg:col-start-1", "lg:row-start-1"],
        ["lg:col-start-2", "lg:row-start-1"],
        ["lg:col-start-1", "lg:row-start-2"],
        ["lg:col-start-2", "lg:row-start-2"]
      ];
      firstFourPlacementClasses.forEach((classes, index) => {
        const tile = productTiles[index];
        if (!tile) return;
        tile.classList.add("js-collection-grid-first-four");
        tile.classList.add(...classes);
      });
    }
    if (shouldInsert2 && !this.$productGrid.querySelector(".js-collection-grid-insert-2")) {
      const secondInsertRowStart = 5;
      const secondInsertPosition = secondInsertProductsStartIndex + 1;
      this.insertCollectionGridInsert({
        insertClass: "js-collection-grid-insert-2",
        dataSource: this.collectionGridInsert2Data,
        desktopPlacementClasses: `lg:col-start-1 lg:row-start-${secondInsertRowStart}`,
        insertPosition: secondInsertPosition,
        templateId: "js-collection-grid-insert-template-2"
      });
      const secondBlockPlacementClasses = [
        ["lg:col-start-3", `lg:row-start-${secondInsertRowStart}`],
        ["lg:col-start-4", `lg:row-start-${secondInsertRowStart}`],
        ["lg:col-start-3", `lg:row-start-${secondInsertRowStart + 1}`],
        ["lg:col-start-4", `lg:row-start-${secondInsertRowStart + 1}`]
      ];
      secondBlockPlacementClasses.forEach((classes, index) => {
        const tile = productTiles[secondInsertProductsStartIndex + index];
        if (!tile) return;
        tile.classList.add("js-collection-grid-second-four");
        tile.classList.add(...classes);
      });
    }
    if (shouldInsert3 && !this.$productGrid.querySelector(".js-collection-grid-insert-3")) {
      const thirdInsertRowStart = 9;
      const thirdInsertPosition = thirdInsertProductsStartIndex + [shouldInsert1, shouldInsert2].filter(Boolean).length;
      this.insertCollectionGridInsert({
        insertClass: "js-collection-grid-insert-3",
        dataSource: this.collectionGridInsert3Data,
        desktopPlacementClasses: `lg:col-start-3 lg:row-start-${thirdInsertRowStart}`,
        insertPosition: thirdInsertPosition,
        templateId: "js-collection-grid-insert-template-3"
      });
      const thirdBlockPlacementClasses = [
        ["lg:col-start-1", `lg:row-start-${thirdInsertRowStart}`],
        ["lg:col-start-2", `lg:row-start-${thirdInsertRowStart}`],
        ["lg:col-start-1", `lg:row-start-${thirdInsertRowStart + 1}`],
        ["lg:col-start-2", `lg:row-start-${thirdInsertRowStart + 1}`]
      ];
      thirdBlockPlacementClasses.forEach((classes, index) => {
        const tile = productTiles[thirdInsertProductsStartIndex + index];
        if (!tile) return;
        tile.classList.add("js-collection-grid-third-four");
        tile.classList.add(...classes);
      });
    }
    if (shouldInsert4 && !this.$productGrid.querySelector(".js-collection-grid-insert-4")) {
      const fourthInsertRowStart = 13;
      const fourthInsertPosition = fourthInsertProductsStartIndex + [shouldInsert1, shouldInsert2, shouldInsert3].filter(Boolean).length;
      this.insertCollectionGridInsert({
        insertClass: "js-collection-grid-insert-4",
        dataSource: this.collectionGridInsert4Data,
        desktopPlacementClasses: `lg:col-start-1 lg:row-start-${fourthInsertRowStart}`,
        insertPosition: fourthInsertPosition,
        templateId: "js-collection-grid-insert-template-4"
      });
      const fourthBlockPlacementClasses = [
        ["lg:col-start-3", `lg:row-start-${fourthInsertRowStart}`],
        ["lg:col-start-4", `lg:row-start-${fourthInsertRowStart}`],
        ["lg:col-start-3", `lg:row-start-${fourthInsertRowStart + 1}`],
        ["lg:col-start-4", `lg:row-start-${fourthInsertRowStart + 1}`]
      ];
      fourthBlockPlacementClasses.forEach((classes, index) => {
        const tile = productTiles[fourthInsertProductsStartIndex + index];
        if (!tile) return;
        tile.classList.add("js-collection-grid-fourth-four");
        tile.classList.add(...classes);
      });
    }
    if (this.hasDeferredInitRun) {
      this.initCollectionGridInsertVideoObserver();
    } else {
      this.needsDeferredVideoObserverInit = true;
    }
  }
  //------------------------------------------------------------------------------------------------
  clearCollectionGridInsertLayout() {
    if (!this.$productGrid) return;
    if (this._collectionGridInsertVideoObserver) {
      this._collectionGridInsertVideoObserver.disconnect();
      this._collectionGridInsertVideoObserver = null;
    }
    this.$productGrid.querySelectorAll(".js-collection-grid-insert, .js-collection-grid-insert-2, .js-collection-grid-insert-3, .js-collection-grid-insert-4").forEach((el) => el.remove());
    this.$productGrid.querySelectorAll(".js-collection-grid-first-four, .js-collection-grid-second-four, .js-collection-grid-third-four, .js-collection-grid-fourth-four").forEach((el) => {
      el.classList.remove(
        "js-collection-grid-first-four",
        "js-collection-grid-second-four",
        "js-collection-grid-third-four",
        "js-collection-grid-fourth-four",
        "lg:col-start-1",
        "lg:col-start-2",
        "lg:col-start-3",
        "lg:col-start-4",
        "lg:row-start-1",
        "lg:row-start-2",
        "lg:row-start-3",
        "lg:row-start-4",
        "lg:row-start-5",
        "lg:row-start-6",
        "lg:row-start-7",
        "lg:row-start-8",
        "lg:row-start-9",
        "lg:row-start-10",
        "lg:row-start-11",
        "lg:row-start-12",
        "lg:row-start-13",
        "lg:row-start-14"
      );
    });
  }
  //------------------------------------------------------------------------------------------------
  initCollectionGridInsertVideoObserver() {
    if (!this.$productGrid) return;
    if (this._collectionGridInsertVideoObserver) {
      this._collectionGridInsertVideoObserver.disconnect();
      this._collectionGridInsertVideoObserver = null;
    }
    const videos = this.$productGrid.querySelectorAll(".js-collection-grid-insert-video");
    if (!videos.length) return;
    this._collectionGridInsertVideoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          var _a;
          const video = entry.target;
          const mediaRoot = video.closest(".js-collection-grid-insert-media");
          const autoplayInViewport = String((_a = mediaRoot == null ? void 0 : mediaRoot.dataset) == null ? void 0 : _a.videoAutoplay).trim().toLowerCase() === "true";
          if (!autoplayInViewport) return;
          const pauseBtn = mediaRoot.querySelector(".js-collection-grid-video-pause-btn");
          const playBtn = mediaRoot.querySelector(".js-collection-grid-video-play-btn");
          if (entry.isIntersecting && video.dataset.videoLoaded !== "true") {
            video.setAttribute("preload", "auto");
            video.load();
            video.dataset.videoLoaded = "true";
          }
          if (entry.isIntersecting) {
            video.play().catch(() => {
            });
            pauseBtn == null ? void 0 : pauseBtn.classList.remove("hidden");
            playBtn == null ? void 0 : playBtn.classList.add("hidden");
          } else {
            video.pause();
            pauseBtn == null ? void 0 : pauseBtn.classList.add("hidden");
            playBtn == null ? void 0 : playBtn.classList.remove("hidden");
          }
        });
      },
      {
        rootMargin: "250px 0px",
        threshold: [0, 0.01]
      }
    );
    videos.forEach((video) => this._collectionGridInsertVideoObserver.observe(video));
  }
  //------------------------------------------------------------------------------------------------
  shouldRenderCollectionGridInsert2() {
    const hasNoActiveFilters = !this.activeFilters || this.activeFilters.length === 0;
    return !this.useThreeProductsPerRow && this.isCollectionGridInsert2Enabled && hasNoActiveFilters;
  }
  //------------------------------------------------------------------------------------------------
  shouldRenderCollectionGridInsert3() {
    const hasNoActiveFilters = !this.activeFilters || this.activeFilters.length === 0;
    return !this.useThreeProductsPerRow && this.isCollectionGridInsert3Enabled && hasNoActiveFilters;
  }
  //------------------------------------------------------------------------------------------------
  shouldRenderCollectionGridInsert4() {
    const hasNoActiveFilters = !this.activeFilters || this.activeFilters.length === 0;
    return !this.useThreeProductsPerRow && this.isCollectionGridInsert4Enabled && hasNoActiveFilters;
  }
  //------------------------------------------------------------------------------------------------
  insertCollectionGridInsert({
    insertClass = "js-collection-grid-insert",
    dataSource = "",
    desktopPlacementClasses = "",
    insertPosition = 4,
    templateId = ""
  } = {}) {
    var _a, _b;
    if (!this.$productGrid) return;
    if (insertClass && this.$productGrid.querySelector(`.${insertClass}`)) return;
    const insertTile = document.createElement("div");
    insertTile.className = `${insertClass} col-span-2 lg:col-span-2 lg:row-span-2 ${desktopPlacementClasses}`.trim();
    insertTile.dataset.gridInsertSource = dataSource;
    const template = templateId ? document.getElementById(templateId) : null;
    const renderedNode = (_b = (_a = template == null ? void 0 : template.content) == null ? void 0 : _a.firstElementChild) == null ? void 0 : _b.cloneNode(true);
    if (renderedNode) {
      insertTile.appendChild(renderedNode);
    }
    const safeInsertPosition = Math.min(insertPosition, this.$productGrid.children.length);
    const referenceNode = this.$productGrid.children[safeInsertPosition];
    if (referenceNode) {
      this.$productGrid.insertBefore(insertTile, referenceNode);
    } else {
      this.$productGrid.appendChild(insertTile);
    }
  }
  //------------------------------------------------------------------------------------------------
  async showMoreProducts() {
    if (this.prefetchedOverflowProducts.length > 0) {
      const overflowBatch = this.prefetchedOverflowProducts.splice(0, this.desktopPostTargetBatchSize);
      await this.displayProducts("append", overflowBatch);
      this.updateLoadMoreVisibility();
      return;
    }
    if (this.enableDesktopStagedLoading && this.hasReachedSilentTarget) {
      this.largeBatchPageInfo += 1;
      this.pageInfo = this.largeBatchPageInfo;
      this.resultsPerPage = this.desktopPostTargetBatchSize;
    } else {
      this.pageInfo += 1;
    }
    this.ssUrl = this.formatSearchSpringUrl();
    const queryToken = this.queryStateToken;
    this.fetchSearchSpringData(queryToken).then((ssData) => {
      if (!ssData) return;
      this.initPage(ssData, "append");
    }).catch((error) => {
      console.error("Error fetching more products:", error);
      this.$loadMoreButtonWrapper.classList.add("hidden");
    });
  }
  //------------------------------------------------------------------------------------------------
  clearResults() {
    this.$productGrid.innerHTML = "";
  }
  //------------------------------------------------------------------------------------------------
  updateCounts() {
    this.$currentProductCount.innerHTML = this.renderedProductCount || this.paginationData.end;
    this.$totalProductCounts.forEach((counter) => {
      counter.innerHTML = this.paginationData.totalResults;
    });
    if (this.activeFilters) {
      this.$filterCountTotals.forEach((counter) => {
        counter.innerHTML = `(${this.activeFilters.length})`;
        if (this.activeFilters.length > 0) {
          counter.classList.remove("hidden");
        } else {
          counter.classList.add("hidden");
        }
      });
    }
    for (var filter in this.filterCounts) {
      const count = this.filterCounts[filter] === 0 ? "" : `(${this.filterCounts[filter]})`;
      const counterID = `filter_count_${filter}`;
      const $counter = document.getElementById(counterID);
      $counter.innerHTML = count;
    }
  }
  // **************************************************************************
  // SORT METHODS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  initSort() {
    this.$sortContent.innerHTML = "";
    this.sortData.options.forEach((sort) => {
      const isBestsellerScoreSort = sort.field === "mfield_custom_ss_bestseller_score";
      if (isBestsellerScoreSort && !this.isBestsellerScoreEnabled) {
        return;
      }
      const sortElement = document.createElement("div");
      sortElement.classList.add("redesign-body-7", "text-charcoal-100", "py-8");
      let checked = "";
      if (sort.active) {
        sortElement.classList.add("active");
        checked = "checked";
        this.$sortLabel.innerHTML = sort.label;
      }
      sortElement.innerHTML += `
        <label class="flex items-center gap-8 cursor-pointer">
          <input 
            type="radio" 
            class="size-20 js-sort-option redesign-radio-btn" 
            data-sort="sort.${sort.field}"
            data-sort-order="${sort.direction}"
            data-sort-label="${sort.label}"
            name="sort"
            value="${sort.field}"
            ${checked}
          >
          ${sort.label} 
        </label>
      `;
      this.$sortContent.appendChild(sortElement);
    });
  }
  //------------------------------------------------------------------------------------------------
  toggleSortModal() {
    var _a, _b;
    if (this.$sortModalWrapper.classList.contains("hidden")) {
      this.$sortModalWrapper.classList.remove("hidden");
      this.$sortButton.setAttribute("aria-expanded", "true");
      window.$lastFocusedEl = document.activeElement;
      trapFocus(this.$sortModal);
      this.$sortModal._onEscape = () => this.toggleSortModal();
      this._outsideSortClickListener = (e) => {
        const clickedInSortModal = this.$sortModal.contains(e.target);
        const clickedSortTrigger = this.$sortButton.contains(e.target);
        if (!clickedInSortModal && !clickedSortTrigger) {
          this.toggleSortModal();
        }
      };
      document.addEventListener("click", this._outsideSortClickListener);
    } else {
      this.$sortModalWrapper.classList.add("hidden");
      this.$sortButton.setAttribute("aria-expanded", "false");
      (_b = (_a = this.$sortModal)._removeTrapFocus) == null ? void 0 : _b.call(_a);
      this.$sortModal._onEscape = null;
      if (this._outsideSortClickListener) {
        document.removeEventListener("click", this._outsideSortClickListener);
        this._outsideSortClickListener = null;
      }
      if (window.$lastFocusedEl) {
        window.$lastFocusedEl.focus();
      }
    }
  }
  //------------------------------------------------------------------------------------------------
  async handleSortChange() {
    this.pageInfo = 1;
    this.resetStagedLoadingState();
    this.toggleSortModal();
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    urlParams.forEach((value, key) => {
      if (key.startsWith("sort.")) {
        urlParams.delete(key);
      }
    });
    if (this.sort) {
      urlParams.set(`${this.sort}`, this.sortOrder);
    }
    window.history.replaceState({}, "", `${url.pathname}?${urlParams.toString()}`);
    this.ssUrl = this.formatSearchSpringUrl();
    const queryToken = ++this.queryStateToken;
    const ssData = await this.fetchSearchSpringData(queryToken);
    if (!ssData) return;
    this.initPage(ssData, "replace");
    this.$sortLabel.innerHTML = this.sortLabel;
  }
  // **************************************************************************
  // FILTER METHODS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  toggleFiltersDrawer() {
    var _a, _b;
    if (this.$filtersDrawerWrapper.classList.contains("-translate-x-full")) {
      this.$filtersDrawerWrapper.classList.remove("-translate-x-full");
      this.$filtersDrawerWrapper.classList.add("translate-x-0");
      this.$filtersBackdrop.classList.remove("opacity-0", "pointer-events-none");
      this.$filtersBackdrop.classList.add("opacity-100");
      this.$filtersButton.setAttribute("aria-expanded", "true");
      document.body.classList.add("ui-active", "overflow-hidden");
      window.$lastFocusedEl = document.activeElement;
      trapFocus(this.$filtersDrawer);
      this.$filtersDrawer._onEscape = () => this.toggleFiltersDrawer();
    } else {
      this.$filtersDrawerWrapper.classList.add("-translate-x-full");
      this.$filtersDrawerWrapper.classList.remove("translate-x-0");
      this.$filtersBackdrop.classList.add("opacity-0", "pointer-events-none");
      this.$filtersBackdrop.classList.remove("opacity-100");
      this.$filtersButton.setAttribute("aria-expanded", "false");
      document.body.classList.remove("ui-active", "overflow-hidden");
      (_b = (_a = this.$filtersDrawer)._removeTrapFocus) == null ? void 0 : _b.call(_a);
      this.$filtersDrawer._onEscape = null;
      if (window.$lastFocusedEl) {
        window.$lastFocusedEl.focus();
      }
    }
    this.toggleFilterClearButton();
  }
  //------------------------------------------------------------------------------------------------
  toggleFilterClearButton() {
    if (this.activeFilters && this.activeFilters.length > 0) {
      this.$filtersClearButtonWrapper.classList.remove("hidden");
      this.$filtersContent.classList.add("pb-120");
    } else {
      this.$filtersClearButtonWrapper.classList.add("hidden");
      this.$filtersContent.classList.remove("pb-120");
    }
  }
  //------------------------------------------------------------------------------------------------
  addActiveFilters() {
    if (!this.filtersData || this.filtersData.length === 0) {
      console.warn("No filters available for this collection.");
      return;
    }
    this.filterCounts = {};
    this.$filtersContent.innerHTML = "";
    this.filtersData.forEach((filter) => {
      const isProductTypeFilter = filter.field === "product_type";
      const isSingleVendorFilter = filter.field === "vendor" && filter.values.length === 1;
      if (isProductTypeFilter && !this.isProductTypeEnabled || isSingleVendorFilter) {
        return;
      } else if ((Shopify == null ? void 0 : Shopify.country) !== "US" && filter.field === "ss_price_range_filter") {
        return;
      }
      this.filterCounts[filter.field] = this.countKeyValues(filter.values, "active", true);
      const filterElement = document.createElement("div");
      filterElement.classList.add("filter-item", "border-b-1", "border-charcoal-10");
      filterElement.innerHTML = `
        <button
          type="button"
          id="acc-cta-${filter.field}"
          class="flex items-center justify-between acc__btn js-acc-btn text-charcoal-100 cursor-pointer h-52"
          aria-expanded="false"
          aria-controls="acc-panel-${filter.field}"
        >
          <h3 class="filter-title redesign-label-2 text-charcoal-100">
            ${filter.label}
            <span
              id="filter_count_${filter.field}"
              class="js-filter-count text-charcoal-80 ml-4"
            >(x)</span>
          </h3>
          <span class="accordion-icons flex items-center justify-center size-32 cursor-pointer">
            ${_JK.icons.plus}
            ${_JK.icons.minus}
          </span>
        </button>
        <div
          id="acc-panel-${filter.field}"
          class="pt-22 pb-38 js-acc-menu redesign-body-7 text-charcoal-100"
          role="region"
          aria-labelledby="acc-cta-${filter.field}"
          aria-hidden="true"
          aria-live="polite"
        >
          <ul
            class="filter-options ${filter.label === "Color" ? "grid grid-cols-2 gap-4" : ""}"
            data-filter-group="${filter.field}"
          >
            ${filter.values.map(
        (value) => `
              <li class="filter-option redesign-body-7 py-8">
                <label class="flex items-center gap-10 cursor-pointer">
                  <input
                    type="checkbox"
                    class="js-filter-option redesign-checkbox-btn"
                    data-filter="filter.${filter.field}"
                    data-value="${value.value}"
                    name="${value.value}"
                    value="${value.value}"
                    ${value.active ? "checked" : ""}
                    aria-checked="${value.active ? "true" : "false"}"
                  >
                  <span class="text-charcoal-130 flex flex-row gap-4">
                    ${value.label}
                    <span class="text-charcoal-80 js-filter-count">(${value.count})</span>
                  </span>
                </label>
              </li>
            `
      ).join("")}
          </ul>
        </div>
      `;
      this.$filtersContent.appendChild(filterElement);
    });
  }
  updateFilterStates() {
    if (!this.filtersData || this.filtersData.length === 0) {
      console.warn("No filters to update.");
      return;
    }
    this.filtersData.forEach((filter) => {
      const filterPanel = this.$filtersContent.querySelector(`#acc-panel-${filter.field}`);
      if (!filterPanel) return;
      const list = filterPanel.querySelector("ul.filter-options");
      if (!list) return;
      list.innerHTML = "";
      list.innerHTML = filter.values.map((value) => `
        <li class="filter-option redesign-body-7 py-8">
          <label class="flex items-center gap-10 cursor-pointer">
            <input 
              type="checkbox" 
              class="js-filter-option redesign-checkbox-btn" 
              data-filter="filter.${filter.field}" 
              data-value="${value.value}"
              name="${value.value}" 
              value="${value.value}" 
              ${value.active ? "checked" : ""}
              aria-checked="${value.active ? "true" : "false"}"
            >
            <span class="text-charcoal-130 flex flex-row gap-4">
              ${value.label}
              <span class="text-charcoal-80">(${value.count})</span>
            </span>
          </label>
        </li>
      `).join("");
      const filterCountEl = this.$filtersContent.querySelector(
        `#filter_count_${filter.field}`
      );
      if (filterCountEl) {
        const activeCount = filter.values.filter((v) => v.active).length;
        filterCountEl.textContent = activeCount > 0 ? `(${activeCount})` : "";
      }
    });
  }
  //------------------------------------------------------------------------------------------------
  initFiltersAccordion() {
    if (this.$filtersContent) {
      const accordion = SDG.accordion({
        dom: {
          btn: "js-acc-btn",
          id: this.$filtersContent.id,
          menu: "js-acc-menu"
        },
        open_option: this.activeFilterGroupIndex,
        type: "accordion"
      });
      accordion.init();
      this.$accordionButtons = this.$filtersContent.querySelectorAll(".js-acc-btn");
      this.$accordionButtons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.filterAccordionListener(e);
        });
      });
    }
  }
  //------------------------------------------------------------------------------------------------
  filterAccordionListener(e) {
    const accBtn = e.target.closest(".js-acc-btn");
    this.activeFilterGroupIndex = Number(accBtn.dataset.index);
  }
  //------------------------------------------------------------------------------------------------
  clearFilters() {
    this.$filterOptions = this.$filtersContent.querySelectorAll(".js-filter-option");
    this.$filterOptions.forEach((option) => {
      option.checked = false;
    });
    this.activeFilters = [];
    this.activeFilterGroupIndex = null;
  }
  //------------------------------------------------------------------------------------------------
  async handleFilterChange(filter, value) {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    if (filter !== "" && value !== "") {
      const existingFilterIndex = this.activeFilters.findIndex((f) => f.key === filter && f.value === value);
      if (existingFilterIndex > -1) {
        this.activeFilters.splice(existingFilterIndex, 1);
      } else {
        this.activeFilters.push({ key: filter, value });
      }
      const keysToDelete = [];
      urlParams.forEach((value2, key) => {
        if (key.startsWith("filter.")) {
          keysToDelete.push(key);
        }
      });
      keysToDelete.forEach((key) => {
        urlParams.delete(key);
      });
      this.activeFilters.forEach((filter2) => {
        urlParams.append(filter2.key, filter2.value);
      });
    } else {
      const keysToDelete = [];
      urlParams.forEach((value2, key) => {
        if (key.startsWith("filter.")) {
          keysToDelete.push(key);
        }
      });
      keysToDelete.forEach((key) => {
        urlParams.delete(key);
      });
      this.activeFilters = [];
    }
    this.pageInfo = 1;
    this.resetStagedLoadingState();
    this.ssUrl = this.formatSearchSpringUrl();
    const queryToken = ++this.queryStateToken;
    const ssData = await this.fetchSearchSpringData(queryToken);
    if (!ssData) return;
    this.initPage(ssData, "replace");
    this.toggleFilterClearButton();
    const query = urlParams.toString();
    const newUrl = query ? `${url.pathname}?${query}` : url.pathname;
    window.history.replaceState({}, "", newUrl);
  }
  //------------------------------------------------------------------------------------------------
  displayFilterSummary() {
    if (!this.filterSummaryData || this.filterSummaryData.length === 0) {
      this.$filterSummaryWrapper.classList.add("hidden");
      this.$filterSummaryWrapper.classList.remove("flex");
      return;
    }
    this.$filterSummaryWrapper.classList.remove("hidden");
    this.$filterSummaryWrapper.classList.add("flex");
    const summaryItems = this.filterSummaryData.map((filter) => {
      const displayLabel = filter.label;
      return `
        <button 
          class="js-remove-filter h-36 border-1 border-charcoal-10 hover:border-charcoal-40 text-charcoal-80 hover:text-charcoal-100 flex justify-center items-center gap-12 px-14 py-10 whitespace-nowrap"
          data-filter="filter.${filter.field}"
          data-value="${filter.value}"
          aria-label="Remove filter ${displayLabel}"
        >
          <span class="filter-summary-item redesign-body-9">
            ${displayLabel}
          </span>
          <span>${_JK.icons.closeSmall}</span>
        </button>
      `;
    }).join(" ");
    this.$filterSummary.innerHTML = summaryItems;
    const removeButtons = this.$filterSummary.querySelectorAll(".js-remove-filter");
    removeButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const filterKey = e.currentTarget.dataset.filter;
        const filterValue = e.currentTarget.dataset.value;
        this.handleFilterChange(filterKey, filterValue);
      });
    });
  }
  // **************************************************************************
  // DATA HELPERS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  getSortFromUrl() {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    const sortParams = Array.from(urlParams.entries()).filter(([key]) => key.startsWith("sort.")).map(([key, value]) => ({ key, value }));
    return sortParams;
  }
  //------------------------------------------------------------------------------------------------
  getFiltersFromUrl() {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    const filterParams = Array.from(urlParams.entries()).filter(([key]) => key.startsWith("filter.")).map(([key, value]) => ({ key, value }));
    return filterParams;
  }
  //------------------------------------------------------------------------------------------------
  countKeyValues(arr, key, value) {
    return arr.reduce((count, obj) => {
      if (obj && obj[key] === value) {
        return count + 1;
      }
      return count;
    }, 0);
  }
}
class CollectionWithPagination extends Collection {
  constructor() {
    super();
    const desktopLimit = this.enableDesktopStagedLoading ? this.desktopInitialBatchSize : _JK.collections.deskResultsPerPage;
    this.pagination = new PaginationController({
      deskLimit: desktopLimit,
      mobLimit: _JK.collections.mobResultsPerPage,
      onChange: (newLimit) => this.handlePaginationChange(newLimit)
    });
    this.resultsPerPage = this.pagination.currentLimit;
  }
  handlePaginationChange(newLimit) {
    console.log("Collection pagination changed to", newLimit);
    this.resultsPerPage = newLimit;
    this.init();
  }
}
const initCollectionPage = () => {
  const $collectionContainer = document.getElementById("js-collection-container");
  if ($collectionContainer) {
    const collection = new CollectionWithPagination();
    void collection.init();
  }
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCollectionPage, { once: true });
} else {
  initCollectionPage();
}
